const initAccordions = () => {
    if ($('.accordion').length) {
        $('body').on('click', '.accordion__item--title', function (e) {
            e.preventDefault();
            if (!$(this).parent('div').hasClass('clicked')) {
                $('.accordion__item').removeClass('clicked');
                $('.accordion__item--hidden').slideUp();
                $(this).parent('div').addClass('clicked');
                $(this).parent('div').find('.accordion__item--hidden').slideDown();
            } else {
                $(this).parent('div').removeClass('clicked');
                $(this).parent('div').find('.accordion__item--hidden').slideUp();
            }
        });
    }
}